/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    parts: [
        'container',
        'content',
        'horizontalRule',
        'bottomHalf',
        'copyright',
        'creditCardIcon',
        'customerService'
    ],
    baseStyle: (ctx) => {
        const {
            theme: {
                components: {Footer}
            }
        } = ctx
        const baseStyle = Footer.baseStyle(ctx)
        return {
            container: {
                width: 'full',
                background: 'stokkeGray.bright'
            },
            content: {
                color: 'stokkeCore.black',
                flexDirection: ['column', 'column', 'column', 'row'],
                marginTop: '40px',
                marginBottom: '64px',
                boxing: {
                    ...baseStyle.content.boxing,
                    px: {
                        base: 4,
                        lg: 6,
                        xl: 8
                    }
                }
            },
            horizontalRule: baseStyle.horizontalRule,
            bottomHalf: baseStyle.bottomHalf,
            copyright: baseStyle.copyright,
            customerService: {
                marginBottom: 6
            },
            StokkeWordBrandLogo: {
                link: {
                    marginBottom: '48px',
                    paddingRight: '19px',
                    width: ['217px', '217px', '357px', '484px'],
                    _hover: {
                        background: 'transparent'
                    }
                },
                logo: {
                    width: '119px',
                    height: '23px'
                }
            },
            footerLinkContainer: {
                width: ['300px', '300px', '357px', '487px'],
                marginBottom: '48px'
            },
            footerIconContainer: {
                display: 'flex',
                flexDirection: 'column',
                gap: {base: 12, lg: 8},
                width: [null, null, '380px', '456px', '487px']
            }
        }
    }
}
